import React, { forwardRef, useState } from 'react'
import { TextArea, fontSize, spacing } from '@retailer-platform/shared-components'
import { css } from '@emotion/react'
import { type DomainMessages, useDomainMessages } from 'domains/collections/utils/domain/intl'
import { CollectionsFormInputWrapper } from './CollectionsFormInputWrapper'

export interface CollectionsFormTextAreaProps
  extends Omit<React.HTMLProps<HTMLTextAreaElement>, 'name' | 'as'> {
  identifier: string
  placeholderId?: DomainMessages
  labelId?: DomainMessages
  showLength?: boolean
}

const styles = css({
  height: 140,
  width: 645,
  marginBottom: spacing.X4,
  paddingTop: spacing.X20,
  fontSize: fontSize.X15,
})

export const CollectionsFormTextArea = forwardRef<
  HTMLTextAreaElement,
  CollectionsFormTextAreaProps
>(
  (
    {
      placeholderId,
      maxLength,
      labelId,
      onChange,
      identifier,
      defaultValue = '',
      showLength,
      ...rest
    },
    ref
  ) => {
    const messages = useDomainMessages({
      label: labelId,
      textPlaceholder: placeholderId || labelId,
    })

    const [value, setValue] = useState(defaultValue)

    const onTextChange = event => {
      onChange && onChange(event)
      setValue(event.target.value)
    }

    return (
      <CollectionsFormInputWrapper
        label={messages.label}
        showLength={showLength}
        maxLength={maxLength}
        value={value as string}
      >
        <TextArea
          {...rest}
          ref={ref}
          maxLength={maxLength}
          onChange={onTextChange}
          placeholder={messages.textPlaceholder}
          name={identifier}
          css={styles}
        />
      </CollectionsFormInputWrapper>
    )
  }
)
